import api from "../../../api/axios";

// Feature-local wrappers for the Client core PATCH editor.
//
// Endpoints (per backend/app/apps/clients/views.py):
//   GET    /api/crm/clients/{id}/    — IsClientAccessible (owner OR share)
//   PATCH  /api/crm/clients/{id}/    — IsClientWriter (owner OR can_edit share)
//
// fetchClientById returns the ClientDetailSerializer payload (full row
// + computed `is_owner` / `can_edit` flags); patchClientById returns
// the same shape after the update.

export const fetchClientById = (clientId) =>
  api.get(`/crm/clients/${clientId}/`).then((res) => res.data);

export const patchClientById = (clientId, body) =>
  api.patch(`/crm/clients/${clientId}/`, body).then((res) => res.data);
